import type { ComputedRef, InjectionKey, Ref } from "vue";
import type { FormValidationController } from "@/modules/formValidation";

export type ValidationScope = "all" | "active";

export interface TabConfig {
  readonly id: string;
  readonly title: string;
  readonly value: string;
  readonly validation: FormValidationController;
  readonly disabled: boolean;
  readonly separatorBefore: boolean;
  readonly iconSettings?: {
    readonly class: string;
    readonly style?: string;
    readonly command?: () => void;
  };
}

export interface TabParentContext {
  readonly registerTabs: Ref<ComputedRef<TabConfig>[]>;
  readonly activeValue: Ref<string>;
  readonly validationScope: ComputedRef<ValidationScope>;
}

export const TabConfigInjectionKey: InjectionKey<TabParentContext> = Symbol("TabInjectionKey");
